module.exports = __webpack_public_path__ + "static/avatar_1-c887fc4211487ed31c29072b4457f899.png";